import React from 'react';

import cn from 'classnames';

import { useCurrentValues, useMultiSelect } from './lib/hooks';
import { IUiMultiSelectProps, TOption } from './model/types';
import { OptionsList, FieldContent, RightIcons } from './ui';
import cls from './UiMultiSelect.module.css';

export const UiMultiSelect = <T extends TOption>({
    options,
    placeholder,
    defaultValues,
    isDisabled = false,
    arrowIconSlot,
    leftIconSlot,
    clearIconSlot,
    needSearch = false,
    onItemClickCb,
    onClearValuesCb,
    optionsListClassNames,
    badgeSlot,
}: IUiMultiSelectProps<T>) => {
    const { onItemClick, clearCurrentValues, isEmptyValues, currentValuesText } = useCurrentValues({
        onClearValuesCb,
        options,
        defaultValues,
    });
    const { onContainerClick, isOpen, searchRef, containerRef } = useMultiSelect({ needSearch });

    return (
        <div
            className={cls.UiMultiSelectContainer}
            onClick={onContainerClick}
            aria-haspopup="listbox"
            aria-expanded={isOpen}
            ref={containerRef}
        >
            <div className={cn(cls.selectedWrapper, isOpen && cls.isOpened)}>
                <FieldContent
                    isEmptyValues={isEmptyValues}
                    currentValuesText={currentValuesText}
                    placeholder={placeholder}
                    leftIconSlot={leftIconSlot}
                />

                {!isDisabled && (
                    <RightIcons
                        isOpen={isOpen}
                        isEmptyValues={isEmptyValues}
                        clearCurrentValues={clearCurrentValues}
                        clearIconSlot={clearIconSlot}
                        arrowIconSlot={arrowIconSlot}
                    />
                )}
            </div>
            {isOpen && (
                <OptionsList
                    isOpen={isOpen}
                    options={options}
                    needSearch={needSearch}
                    searchRef={searchRef}
                    onItemClick={onItemClick}
                    onItemClickCb={onItemClickCb}
                    optionsListClassNames={optionsListClassNames}
                    anchorRef={containerRef}
                    onClose={onContainerClick}
                    badgeSlot={badgeSlot}
                />
            )}
        </div>
    );
};
